<template>
  <div class="row justify-center q-my-md">
    <q-spinner
      color="primary"
      :size="isMobile ? '2em' : '2.5em'"
      :thickness="isMobile ? 2 : 2.5"
    />
  </div>
</template>
